import { render, staticRenderFns } from "./GrupoMenuSite.vue?vue&type=template&id=32bf261e&scoped=true"
import script from "./GrupoMenuSite.vue?vue&type=script&lang=js"
export * from "./GrupoMenuSite.vue?vue&type=script&lang=js"
import style0 from "./GrupoMenuSite.vue?vue&type=style&index=0&id=32bf261e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32bf261e",
  null
  
)

export default component.exports